import { Record } from 'immutable';

export const Efector = new Record({
  id: null,
  isNew: true,
  isPending: false,
  email: null,
  dni: null,
  cuit: null,
  apellido: null,
  nombre: null,
  localidadId: null,
  provinciaId: null,
  telefono1: null,
  telefono2: null,
  especialidadId: null,
  lastLogin: null,
  dtCreated: null,
  dtUpdated: null,
  dtDeleted: null,
  created_at: new Date(),
  updated_at: new Date(),
});

export function createEfector(data) {
  return new Efector({
    id: data.id,
    isNew: false,
    email: data.email,
    dni: data.dni,
    cuit: data.cuit,
    apellido: data.apellido,
    nombre: data.nombre,
    localidadId: data.localidadId || "",
    provinciaId: data.provinciaId || "",
    telefono1: data.telefono1,
    telefono2: data.telefono2,
    especialidadId: data.especialidadId || "",
    lastLogin: data.lastLogin,
    dtCreated: data.dtCreated,
    dtUpdated: data.dtUpdated,
    dtDeleted: data.dtDeleted,
    updated_at: new Date(),
  });
}
